export const BASE_TOOL_COMMON_PROPS = {
  id: undefined,
  name: undefined,
  originalParameters: [],
  maximumDuration: undefined,
  advancedParametersCollapsed: true,
  configVersion: undefined,
};

export const DEFAULT_TOOL_ITEM_PROPS = [
  'id',
  'name',
  'redacted',
  'itemType',
  'valueUnitOfMeasure',
  'signalMetadata',
  'conditionMetadata',
  'assets',
];
